import { t } from "@/i18n-js/instance";
import {
  communityBillingPath,
  planSettingsPath,
} from "@/react/helpers/urlHelpers/index";

const localeRoot = "pricing_plans.plan_settings";

export interface BillingTab {
  value: "plans" | "billing";
  label: string;
  path: string;
}

export const BILLING_TABS: BillingTab[] = [
  {
    value: "plans",
    label: t(`${localeRoot}.tabs.plans`),
    path: planSettingsPath(),
  },
  {
    value: "billing",
    label: t(`${localeRoot}.tabs.billing`),
    path: communityBillingPath(),
  },
];
